// Styles
import '../scss/main.scss';

// Scripts
import { offer } from '@shop/frontend/dist/desktop/index';

$(document).ready(function () {
  offer.getState(function (data) {
    const cmp = data.query.cmp;

    if (cmp === 'false') {
      $('.cmp-hide').hide();
      $('.journals').hide();
      $('.cmp-show').show();
      $('.cmp-img-2').attr({
        src: '/static/common/shared/cmp/wallpapers-cmp.png',
        srcset: '/static/common/shared/cmp/wallpapers-cmp@2x.png 1.5x',
      });
    }
  });
  /*accordion*/
  var content = $('.accordion-content');
  content.hide();
  $('.active .accordion-content').slideDown();
  $('.accordion-row').click(function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active').find(content).slideUp();
    } else {
      content.slideUp();
      $('.accordion-row.active').removeClass('active');
      $(this).addClass('active').find(content).slideDown();
    }
  });
  /*accordion end*/

  const hoursElem = $('#hrs');
  const minutesElem = $('#min');
  const secondsElem = $('#sec');
  let initialTimeInSeconds = 15 * 60;
  let timeInSeconds = initialTimeInSeconds;

  let interval = setInterval(function () {
    let hours = Math.floor(timeInSeconds / 3600);
    let minutes = Math.floor((timeInSeconds - hours * 3600) / 60);
    let seconds = timeInSeconds % 60;

    hoursElem.text(pad(hours));
    minutesElem.text(pad(minutes));
    secondsElem.text(pad(seconds));

    timeInSeconds--;

    if (timeInSeconds < 0) {
      // clearInterval(interval);
      // hoursElem.text('00');
      // minutesElem.text('00');
      // secondsElem.text('00');
      timeInSeconds = initialTimeInSeconds;
    }
  }, 1000);

  function pad(number) {
    return number < 10 ? '0' + number : number;
  }
});
